module.exports = __webpack_public_path__ + "static/media/MUSEAbadge-black-p-800.189c43f9.jpeg";